import {PartialGameDomainService} from "../../../domain/partial-game/services/partial-game.domain.service";
import {PartialGameRequestParams} from "../../../domain/partial-game/models/partial-game.request-params";
import {DeltaHandler} from "../../../infrastructure/handlers/delta-handler";
import {BaseApiRequestParams} from "../../../infrastructure/models/params/base-api-request-params";
import {DatetimeUtils} from "../../../infrastructure/utils/datetime-utils";
import {ScoresListWidgetController} from "../scores-list-widget.controller";
import {ScoresListWidgetState} from "../models/scores-list-widget.state";
import {ACTION_TYPES, COMPONENT_STATES, HISTORY_ACTIONS} from "../../../core/consts";
import {SCORES_LIST_WIDGET} from "../scores-list-widget.consts";
import {UserSelectionsManager} from "../../../core/managers/user-selections.manager";

export class ScoresListWidgetFetchHandler extends DeltaHandler {
  controller: ScoresListWidgetController;
  state: ScoresListWidgetState;
  _service: PartialGameDomainService;
  datetimeUtils: DatetimeUtils;
  userSelectionsManager: UserSelectionsManager;

  static injectables = [PartialGameDomainService, DatetimeUtils, UserSelectionsManager];

  constructor(service: PartialGameDomainService, datetimeUtils: DatetimeUtils, userSelectionsManager: UserSelectionsManager) {
    super(service);

    this.datetimeUtils = datetimeUtils;
    this.userSelectionsManager = userSelectionsManager;
  }

  async onLoaded() {
    super.onLoaded();

    this.state.alwaysShowAllActiveCompetitions = this.appStore.state.settings.bootstrapSettings.alwaysShowAllActiveCompetitions
    this.state.inputCompetitionsIds = this.controller.props.competitionIds;
    this.state.showCompetitionsEmptyState = this.state.alwaysShowAllActiveCompetitions && !!this.state.inputCompetitionsIds;

    if (this.state.showCompetitionsEmptyState) {
      await this.controller.action(SCORES_LIST_WIDGET.ACTION_TYPES.competitionsFetch);
    }

    const isBack: Boolean = !this.state.appState.settings.isWidget && this.historyManager.action === HISTORY_ACTIONS.pop;

    const sportTypeIdChanged = (this.state.sportTypeId && this.state.sportTypeId.toString()) !== (this.controller.props.sportTypeId && this.controller.props.sportTypeId.toString());
    const dateChanged: Boolean = this.state.filterDate.toString() !== this.controller.props.date.toString();
    const isPartialFetch = isBack && !sportTypeIdChanged && !dateChanged && !!this.state.dataSource;

    if (dateChanged) {
      this.state.filterDate = this.controller.props.date;
    }

    this.state.isLive = this.controller.props.isLive;

    if (sportTypeIdChanged) {
      this.state.sportTypeId = this.controller.props.sportTypeId;
    }

    if (!isPartialFetch) {
      this.store.clearGames();
    }

    this.action({isPartialFetch});
    this.controller.action(ACTION_TYPES.scoresDisplayHandler)
  }

  get requestParams(): BaseApiRequestParams {
    const competitionIds: Array<Number> = this.controller.props.competitionIds;
    const competitorIds: Array<Number> = this.controller.props.competitorIds;
    const sportTypeId: Array<Number> = [this.state.sportTypeId];
    const startDate: String = this.datetimeUtils.toServerDate(this.state.filterDate);
    const endDate: String = this.datetimeUtils.toServerDate(this.state.filterDate);
    const favoriteCompetitions: Array<Number> = this.userSelectionsManager.competitionsIds;
    const showOdds: Boolean = this.appStore.state.showOdds;
    const competitionsLimit = this.state.competitionsLimit;
    const onlyLiveGames = this.state.isLive;
    const topBookmaker = this.state.appState.topBookmakerId;

    const requestParams: PartialGameRequestParams = new PartialGameRequestParams(null, competitionIds, competitorIds, sportTypeId,
      null, startDate, endDate, null, null, showOdds, favoriteCompetitions, competitionsLimit, false,
      onlyLiveGames, null,null,null,null,null, null, null, topBookmaker);

    return requestParams;
  }

  async action(params) {
    const isPartialFetch = params && params.isPartialFetch;
    const force = params && params.force;

    const dataSource = await this.fetch(this.createDomainParams(), isPartialFetch, force);

    await this.controller.action(ACTION_TYPES.populateData, {dataSource});

    this.store.setComponentState(COMPONENT_STATES.loaded);

    return dataSource;
  }

  onDidUpdate(prevProps, nextProps) {
    super.onDidUpdate(prevProps, nextProps);

    const showOddsChanged = prevProps.showOdds !== nextProps.showOdds;
    const sportTypeIdChanged = (prevProps.sportTypeId && prevProps.sportTypeId.toString()) !== (nextProps.sportTypeId && nextProps.sportTypeId.toString());
    const dateChanged: Boolean = (nextProps.date.toDateString() !== prevProps.date.toDateString());
    const isLiveChanged = prevProps.isLive !== nextProps.isLive;

    const shouldClearGames = sportTypeIdChanged || dateChanged;
    const isPartialFetch = showOddsChanged && !sportTypeIdChanged && !dateChanged;

    if (dateChanged) {
      this.state.filterDate = nextProps.date;
    }

    if (isLiveChanged) {
      this.state.isLive = nextProps.isLive;
    }

    if (showOddsChanged || sportTypeIdChanged || dateChanged || isLiveChanged) {
      shouldClearGames && this.store.clearGames();
      this.action({isPartialFetch});
    }
  }
}
